import { useQuery } from '@tanstack/react-query';

import accounts, { LimitsDetails } from '@clients/accountsClient';
import notifyAPIError from '@utils/notifyAPIError';

const { getLimits } = accounts();

const useGetLimits = (
    accountId: number,
    onSuccess?: (data: LimitsDetails) => void,
    onError?: () => void,
) => {
    const { data, error, isError, isLoading, refetch } = useQuery(
        ['overviewCreditLimits', accountId],
        () => getLimits({ accountId }),
        {
            onSuccess: onSuccess,
            onError: (error) => {
                notifyAPIError(error);
                onError();
            },
        },
    );
    return { data, error, isError, isLoading, refetch };
};
export default useGetLimits;
